import { render } from "./Invoices.vue?vue&type=template&id=c63d8298"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"
script.render = render

export default script